import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Card, CardHeader, Table, Badge } from "reactstrap"
import Header from "../../components/Headers/Header"
import { getScheduledOrders } from "../../apollo/server"
import { useQuery, gql } from "@apollo/client"

interface ScheduledOrder {
  _id: string
  orderId: string
  orderType: string
  orderStatus: string
  scheduledTime: string
  orderAmount: number
  paymentMethod: string
  createdAt: string
  restaurant?: { _id: string; name: string }
  user?: { _id: string; name: string; phone: string }
}

const yen = (n: number) => `¥${Math.round(n || 0).toLocaleString()}`
const fmt = (s: string) => {
  if (!s) return "-"
  const d = new Date(isNaN(Number(s)) ? s : Number(s))
  return isNaN(d.getTime()) ? "-" : d.toLocaleString("ja-JP")
}

// 予約注文(SCHEDULED)の一覧（読み取り専用）。配達希望時刻のリードタイム前に自動配車される。
const Scheduled: React.FC = () => {
  const { t } = useTranslation()
  const { loading, error, data } = useQuery(gql`${getScheduledOrders}`, { fetchPolicy: "cache-and-network", pollInterval: 60000 })

  const orders: ScheduledOrder[] = (data && data.scheduledOrders) || []

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-3">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">{t("ScheduledTitle")}</h3>
                <small className="text-muted">{t("ScheduledHint")}</small>
              </CardHeader>

              {error && <p className="px-4">{`${t("Error")}! ${error.message}`}</p>}
              {loading && !data && <p className="px-4">{t("Loading")}</p>}
              {!loading && orders.length === 0 && <p className="px-4 text-muted">{t("ScheduledNoData")}</p>}

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">{t("ScheduledTimeCol")}</th>
                    <th scope="col">{t("CourierOrderId")}</th>
                    <th scope="col">{t("ScheduledType")}</th>
                    <th scope="col">{t("ScheduledStore")}</th>
                    <th scope="col">{t("CourierUser")}</th>
                    <th scope="col">{t("TipReportTotal")}</th>
                    <th scope="col">{t("ScheduledPayment")}</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(o => (
                    <tr key={o._id}>
                      <td>
                        <Badge color="primary" pill>
                          {fmt(o.scheduledTime)}
                        </Badge>
                      </td>
                      <td>{o.orderId}</td>
                      <td>{o.orderType === "COURIER" ? t("ScheduledCourier") : t("ScheduledRestaurant")}</td>
                      <td>{o.orderType === "COURIER" ? "-" : o.restaurant ? o.restaurant.name : "-"}</td>
                      <td>{o.user ? o.user.name : "-"}</td>
                      <td>{yen(o.orderAmount)}</td>
                      <td>{o.paymentMethod === "STRIPE" ? t("ScheduledCard") : t("ScheduledCod")}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default Scheduled
